import { atom } from 'recoil';

export const isNewVendorDriverModalOpenAtom = atom<boolean>({
  key: 'isNewVendorDriverModalOpenAtom',
  default: false,
});
